// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs ul{display:flex;height:2.35rem;background-color:#fff;border-bottom:1px solid #dee2e6;margin:0}.tabs ul a{font-weight:400;text-decoration:none;display:flex;border:1px solid transparent;padding:.5rem 1rem}@media(max-width:767px){.tabs ul a{padding:.5rem .5rem}}.tabs ul a.active{color:#495057;border-color:#dee2e6 #dee2e6 #fff}.tabs ul a:hover{border-color:#e9ecef #e9ecef #dee2e6}", ""]);
// Exports
module.exports = exports;
